import React, { useState } from "react"
import { useShallow } from "zustand/react/shallow"
import Modal from "components/Modal/Modal"
import PrimeField from "components/PrimeField/PrimeField"
import { AUTHORING_TASKS } from "constants/tasks.js"
import fileDownload from "utilities/fileDownload"

// apis
import { usePostPrsPreview } from "api/hooks/studies/useAuthoringApi"
import useAuthoringViewStore from "../../hooks/stores/useAuthoringViewStore"
import useAuthoringPreviewActions from "../../hooks/actions/useAuthoringPreviewActions"

// context
import useAppState from "context/hooks/useAppState"

const DownloadPreviewModal = ({ authoringId, openDownloadPreview, setOpenDownloadPreview }) => {
  const [downloadFileType, setDownloadFileType] = useState("PDF")
  const [showValidations, setShowValidations] = useState(false)
  const postPrsPreview = usePostPrsPreview()
  const { onPrsPreview } = useAuthoringPreviewActions()

  const { formSection } = useAuthoringViewStore(
    useShallow((state) => ({
      formSection: state.formSection,
    }))
  )

  const { openToastNotification, taskType } = useAppState()

  const downloadCTGFile = async () => {
    let previewType = downloadFileType.toLowerCase()
    // openToastNotification("info", "Note", "Retrieving file")

    const onSuccess = async (data) => {
      if (data?.file_url) {
        try {
          let blob = await fetch(data.file_url).then((r) => r.blob())
          fileDownload(blob, `${previewType}_preview`, `application/${previewType}`)
          setOpenDownloadPreview(false)
        } catch (err) {
          console.log(err)
        }
      }
    }

    onPrsPreview({
      authoringId,
      formSection,
      previewType,
      showValidations,
      callback: onSuccess,
    })
    // try {
    //   let type = downloadFileType.toLowerCase()
    //   openToastNotification("info", "Note", "Retrieving file")
    //   setOpenDownloadPreview(false)
    //   postPrsPreview(
    //     {
    //       id: `${authoringId}/prs-preview`,
    //       body: {
    //         preview_type: downloadFileType,
    //         show_validations: showValidations,
    //         results_section:
    //           formSection?.id === "delayedResultsCertification" ? "delayed_results_certification" : "results",
    //       },
    //     },
    //     {
    //       onSuccess: async (resp) => {
    // if (resp.data) {
    //   try {
    //     let blob = await fetch(resp.data.file_url).then((r) => r.blob())
    //     fileDownload(blob, `${type}_preview`, `application/${type}`)
    //   } catch (err) {
    //     console.log(err)
    //   }
    // }
    //       },
    //     }
    //   )
    // } catch (err) {
    //   console.log("ERR: ", err)
    // }
  }

  return (
    <Modal
      title="Download preview"
      type="confirm"
      open={openDownloadPreview}
      setOpenModal={setOpenDownloadPreview}
      onCancel={() => setOpenDownloadPreview(false)}
      confirmLoading={AUTHORING_TASKS.prsPreview === taskType}
      onOk={() => downloadCTGFile()}
      okText="Download"
      size="sm"
      hideImage={true}
    >
      <div className="download-preview-content-container">
        <PrimeField
          schema={{
            type: "dropdown",
            id: "download-preview-file-type",
            className: "full",
            placeholder: "File type",
            items: ["PDF", "RTF"],
            onChange: (val) => {
              if (val === "RTF") setShowValidations(false)
              setDownloadFileType(val)
            },
            containerClassName: "field w-full",
          }}
          value={downloadFileType}
        />
        <PrimeField
          schema={{
            type: "checkbox",
            containerClassName: "field",
            className: "checkbox",
            label: "Include validations",
            onChange: (val) => setShowValidations(val),
          }}
          disabled={downloadFileType === "RTF"}
          value={showValidations}
        />
      </div>
    </Modal>
  )
}

export default DownloadPreviewModal
